<template>
  <van-popup class="wrap" v-model="value" @click-overlay="setTime(false)" :close-on-click-overlay="false">
    <div v-show="value" class="m-tier">
      <!-- 年份 月份 -->
      <div class="month">
        <ul class="m-box">
          <li class="m-year">
            <i class="icon icon-arrow-left" @click.stop="prevMonth()"></i>
            <span>{{yearData}}年{{monthData}}月</span>
            <i class="icon icon-arrow-right" @click.stop="nextMonth()"></i>
          </li>
          <li class="m-week">
            <span>日</span>
            <span>一</span>
            <span>二</span>
            <span>三</span>
            <span>四</span>
            <span>五</span>
            <span>六</span>
          </li>
          <li class="m-day">
            <div class="m-row" v-for="( arr,index ) in dayArrays" :key="index">
              <div class="m-chunk" v-for="(item) in arr" @click.stop="selected(item,index)" :key="item.id">
              <span class="m-date"
                    :class="{'m-today':item.today&&item.isThisMonth,'m-active': item.dayNum === activeIndex,'m-disabled':!item.state||item.state && item.state.code!=='000'}">{{item.dayNum}}</span>
                <span class="m-alert"
                      :class="{'m-full':item.state && item.state.code==='010','m-on':item.state && item.state.code==='000'}"
                      v-if="item.dayNum" v-html="dateTips(item)"></span>
              </div>
              <div class="m-time" v-if="index === timeIndex && testDateTimeList.length>0">
                <p class="text-center">请选择体检时间段</p>
                <p class="time-quantum">
                  <button v-for="(r,index) in testDateTimeList" @click.stop="selectTime(r,index)"
                          :class="{'m-disabledTime':r.SYRS000===0,'m-activeTime':index === activeTime}" :key="index">
                    {{r.BOOK_TIME}}{{person ? (r.SYRS000 ? '(' + r.SYRS000 + '人)' : '(已满)') : ''}}
                  </button>
                </p>
              </div>
            </div>
          </li>

          <li class="m-foot">
            <button class="btn" @click.stop="mBack('back')" v-if="back">返回</button>
            <button class="btn" @click.stop="setTime(false)" v-if="!back">取消</button>
            <button :disabled="affirmTime===''" class="btn" :class="{'btn-dis': affirmTime===''}"
                    @click.stop="setTime(true)">确定
            </button>
          </li>
        </ul>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import Vue from 'vue'

Vue.use(Popup)
/**
   *  <date-picker v-model="dateState"  @getTime="getTime"></date-picker>
   *   v-model 控制显示/隐藏   @getTime 返回一个时间段    timeQuantum：时间段
   */
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    back: {
      type: Boolean,
      default: false
    },
    person: {
      type: Boolean,
      default: true
    },
    dateList: {
      type: Array,
      default: []
    },
    dateTimeList: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      yearData: '',
      monthData: '',
      dayData: '',
      days: '', // 当月多少天
      week: '', //当天星期几
      dayArrays: [],
      activeDate: '',
      activeIndex: '', //选择天
      timeIndex: '', //时间选区
      activeTime: '', //选择时间段下标
      affirmTime: '', //时间段
      timeQuantum: []
    }
  },
  created () {
    const {year, month, day} = this.showDate() //获得当前年月日
    this.getData(year, month, day) //获得日历数据
  },
  watch: {
    testDateList (newVal) {
      if (newVal) {
        this.updateView()
      }
    },
    testDateTimeList (newVal) {
      if (newVal) {
        this.updateView()
      }
    }
  },
  methods: {
    dateTips (item) {
      if (item.state && item.state.code === '010') {
        return '已满'
      } else if (item.state && item.state.code === '020') {
        return '休息'
      } else if (item.state && item.state.code === '000') {
        return '可约'
      } else {
        return '&nbsp;'
      }
    },
    updateView () {
      const {year, month, day} = this.showDate(this.activeDate ? new Date(this.activeDate.dateStr) : new Date(this.testDateList[0].testDate)) //获得当前年月日
      this.getData(year, month, day) //获得日历数据
    },
    selectTime (r, index) {
      if (r.SYRS000 > 0) {
        this.activeTime = index
        this.affirmTime = r.BOOK_TIME
      } else {
        this.activeTime = ''
        this.affirmTime = ''
      }
    },
    selected (item, index) {
      if (item.state && item.state.code === '000') {
        this.activeDate = item
        this.activeIndex = item.dayNum
        this.dayData = item.dayNum < 10 ? '0' + item.dayNum : item.dayNum
        this.timeIndex = index
        this.activeTime = ''
        this.affirmTime = ''
        this.$emit('selectDate', `${this.yearData}-${this.monthData}-${this.dayData}`)
      }
    },
    setTime (bool) {
      if (bool) {
        this.$emit('getTime', {
          date: `${this.yearData}-${this.monthData}-${this.dayData}`,
          time: this.affirmTime || ''
        })
      }
      if (!this.back) this.$emit('input', false)
    },
    mBack () {
      this.$emit('input', false)
    },
    showDate (d) {
      let date = d || new Date() // 获得当前日期
      this.yearData = date.getFullYear()
      this.monthData = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      // this.currentDate = `${date.getFullYear()}年${(date.getMonth() + 1)<10?'0'+ (date.getMonth() + 1):(date.getMonth()+1)}月`
      return {year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()}
    },
    prevMonth () {
      this.activeIndex = ''
      this.timeIndex = ''
      this.dayData = ''
      let y = this.yearData
      let m = parseInt(this.monthData)
      if (m === 1) {
        y -= 1
        m = 13
      }
      this.yearData = y
      this.monthData = (m - 1) < 10 ? '0' + (m - 1) : m - 1
      this.getData(y, m - 1)
    },
    nextMonth () {
      this.activeIndex = ''
      this.timeIndex = ''
      this.dayData = ''
      let y = this.yearData
      let m = parseInt(this.monthData)
      if (m >= 12) {
        y += 1
        m = 0
      }
      this.yearData = y
      this.monthData = (m + 1) < 10 ? '0' + (m + 1) : m + 1
      this.getData(y, m + 1)
    },
    getData (year, month, day) {
      this.days = (new Date(year, month, 0)).getDate() // 获得当月总天数
      this.week = new Date(year, month - 1, 1).getDay() // 当月第一天星期几
      // 获得当月数据对象
      let vessel = []
      let dateStr
      for (let i = 1; i <= this.days; i++) {
        dateStr = [year, ((month) + Math.pow(10, 2)).toString().substr(1), ((i) + Math.pow(10, 2)).toString().substr(1)].join('-')
        vessel.push({
          state: (this.testDateList || []).find((date) => date.testDate === dateStr),
          dateStr: dateStr,
          dayNum: i,
          weekDay: new Date(year, month - 1, i).getDay(),
          selected: i === +day,
          isThisMonth: parseInt(this.monthData) === new Date().getMonth() + 1, //是否是本月
          today: i === new Date().getDate() //是否是今天
        })

        if (this.activeDate && this.activeDate.dateStr === dateStr) {
          this.activeDate = vessel[vessel.length - 1]
        }
      }
      // 每月第一天不是星期天 补空
      let sum = vessel[0].weekDay
      for (let i = 0; i < sum; i++) {
        if (sum <= 6 && sum !== 0) {
          vessel.unshift({})
        }
      }
      // 分星期重组数据
      let arr = []
      let row = []
      for (let r = 1; r <= vessel.length; r++) {
        row.push(vessel[r - 1])
        if (r % 7 === 0 || r === vessel.length) {
          arr.push(row)
          row = []
        }
      }
      this.dayArrays = arr
    }
  },
  computed: {
    testDateList: {
      get: function () {
        return this.dateList
      }
    },
    testDateTimeList: {
      get: function () {
        return this.dateTimeList
      }
    },
    disableSubmit () {
      return !this.activeDate || (this.activeDate && this.activeDate.state && this.activeDate.state.specialProDtos.length > 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  .van-popup /deep/{
    width: 90%;
    month {
      flex: 0 337px;
    }

    .m-box {
      margin: auto;
      padding: 10px 10px;
      background-color: #ffffff;
      border-radius: 4px;
      .m-year {
        display: flex;
        justify-content: space-between;
        height: 40px;
        line-height: 40px;
      }
      .m-week {
        width: 100%;
        height: 36px;
        line-height: 36px;
        color: #999999;
        span {
          display: inline-block;
          width: 14.28%;
          text-align: center;
        }
      }
      .m-day {
        width: 100%;
        .m-alert {
          display: block;
          font-size: 12px;
          line-height: 1;
          color: #dddddd;
        }
        .m-on {
          color: rgba(57, 203, 151, 0.75);
        }
        .m-off {
          color: #3ec8ff;
        }
        .m-full {
          color: #ff5c43;
        }
        .m-row {
          width: 100%;
          min-height: 40px;
          .m-chunk {
            display: inline-block;
            width: 14.28%;
            text-align: center;
            .m-date {
              display: inline-block;
              margin: 4px auto;
              width: 26px;
              height: 26px;
              line-height: 26px;
            }
          }
        }
      }
      .m-foot {
        width: 100%;
        padding-top: 10px;
        text-align: center;
        > button {
          height: 30px;
          padding: 0 15px;
          border: 1px solid rgb(242, 89, 48);
          &:first-child {
            margin-right: 40px;
            background-color: #ffffff;
            color: rgb(242, 89, 48);
          }
          &:last-child {
            background-color: rgb(242, 89, 48);
            color: #ffffff;
          }
        }
      }
    }

    .m-date {
      color: #39CB97;
    }

    .m-disabled {
      color: #999;
      text-decoration: line-through;
    }

    .m-today {
      color: #f25930;
    }

    .m-active {
      color: #ffffff;
      background-color: #f25930;
      border-radius: 50%;
    }

    .m-time {
      width: 100%;
      height: 135px;
      text-align: center;
      padding: 0 15px;
      border-top: 1px solid #f5f5f5;
      border-bottom: 1px solid #f5f5f5;
      overflow-y: auto;
      >p{
        line-height: 44px;
      }
      >.time-quantum {
        display: flex;
        flex-wrap: wrap;
        justify-content: left;
        align-content: space-between;
        button {
          width: 130px;
          height: 30px;
          line-height: 28px;
          border-radius: 4px;
          margin-right: 15px;
          margin-bottom: 15px;
          border: 1px solid #dddddd;
          background-color: #ffffff;
          &:nth-child(even) {
            margin-right: 0;
          }
        }

        .m-activeTime {
          border-color: #f25930;
          color: #ffffff;
          background-color: #f25930;
        }

        .m-disabledTime {
          border-color: #dddddd;
          color: #ffffff;
          background-color: #dddddd;
        }
      }
    }

    .btn-dis {
      border: 1px solid #ddd !important;
      background-color: #ddd !important;
    }
  }
  /*.m-tier {*/
    /*position: absolute;*/
    /*top: 0;*/
    /*left: 0;*/
    /*right: 0;*/
    /*bottom: 0;*/
    /*margin: auto;*/
    /*z-index: 100;*/
    /*background-color: rgba(7, 17, 27, 0.7);*/
    /*display: flex;*/
    /*display: -webkit-flex;*/
    /*align-items: center;*/
    /*justify-content: center;*/
  /*}*/

  /*.month {*/
    /*flex: 0 337px;*/
  /*}*/

  /*.m-box {*/
    /*margin: auto;*/
    /*padding: 10px 10px;*/
    /*background-color: #ffffff;*/
    /*border-radius: 4px;*/
    /*.m-year {*/
      /*display: flex;*/
      /*justify-content: space-between;*/
      /*height: 40px;*/
      /*line-height: 40px;*/
    /*}*/
    /*.m-week {*/
      /*width: 100%;*/
      /*height: 36px;*/
      /*line-height: 36px;*/
      /*color: #999999;*/
      /*span {*/
        /*display: inline-block;*/
        /*width: 14.28%;*/
        /*text-align: center;*/
      /*}*/
    /*}*/
    /*.m-day {*/
      /*width: 100%;*/
      /*.m-alert {*/
        /*display: block;*/
        /*font-size: 12px;*/
        /*line-height: 1;*/
        /*color: #dddddd;*/
      /*}*/
      /*.m-on {*/
        /*color: rgba(57, 203, 151, 0.75);*/
      /*}*/
      /*.m-off {*/
        /*color: #3ec8ff;*/
      /*}*/
      /*.m-full {*/
        /*color: #ff5c43;*/
      /*}*/
      /*.m-row {*/
        /*width: 100%;*/
        /*min-height: 40px;*/
        /*.m-chunk {*/
          /*display: inline-block;*/
          /*width: 14.28%;*/
          /*text-align: center;*/
          /*.m-date {*/
            /*display: inline-block;*/
            /*margin: 4px auto;*/
            /*width: 26px;*/
            /*height: 26px;*/
            /*line-height: 26px;*/
          /*}*/
        /*}*/
      /*}*/
    /*}*/
    /*.m-foot {*/
      /*width: 100%;*/
      /*padding-top: 10px;*/
      /*text-align: center;*/
      /*> button {*/
        /*height: 30px;*/
        /*padding: 0 15px;*/
        /*border: 1px solid rgb(242, 89, 48);*/
        /*&:first-child {*/
          /*margin-right: 40px;*/
          /*background-color: #ffffff;*/
          /*color: rgb(242, 89, 48);*/
        /*}*/
        /*&:last-child {*/
          /*background-color: rgb(242, 89, 48);*/
          /*color: #ffffff;*/
        /*}*/
      /*}*/
    /*}*/
  /*}*/

  /*.m-date {*/
    /*color: #39CB97;*/
  /*}*/

  /*.m-disabled {*/
    /*color: #999;*/
    /*text-decoration: line-through;*/
  /*}*/

  /*.m-today {*/
    /*color: #f25930;*/
  /*}*/

  /*.m-active {*/
    /*color: #ffffff;*/
    /*background-color: #f25930;*/
    /*border-radius: 50%;*/
  /*}*/

  /*.m-time {*/
    /*width: 100%;*/
    /*height: 135px;*/
    /*text-align: center;*/
    /*padding: 0 15px;*/
    /*border-top: 1px solid #f5f5f5;*/
    /*border-bottom: 1px solid #f5f5f5;*/
    /*overflow-y: auto;*/
    /*> p {*/
      /*display: flex;*/
      /*line-height: 44px;*/
      /*flex-wrap: wrap;*/
      /*justify-content: center;*/
      /*align-content: space-between;*/
      /*button {*/
        /*width: 130px;*/
        /*height: 30px;*/
        /*line-height: 28px;*/
        /*border-radius: 4px;*/
        /*margin-right: 15px;*/
        /*margin-bottom: 15px;*/
        /*border: 1px solid #dddddd;*/
        /*background-color: #ffffff;*/
        /*&:nth-child(even) {*/
          /*margin-right: 0;*/
        /*}*/
      /*}*/

      /*.m-activeTime {*/
        /*border-color: #f25930;*/
        /*color: #ffffff;*/
        /*background-color: #f25930;*/
      /*}*/

      /*.m-disabledTime {*/
        /*border-color: #dddddd;*/
        /*color: #ffffff;*/
        /*background-color: #dddddd;*/
      /*}*/
    /*}*/
  /*}*/

  /*.btn-dis {*/
    /*border: 1px solid #ddd !important;*/
    /*background-color: #ddd !important;*/
  /*}*/
</style>
